import { Link } from 'react-router-dom'
import useMe from '../hooks/useMe.js'
import { isAuthenticated } from '../lib/auth.js'
import { redirectToOAuthSignIn } from '../utils/oauth.js'
import { useAuthConfig } from '../config/appConfig.jsx'
import Avatar from './Avatar.jsx'
import { BTN_PRIMARY_SM } from '../lib/ui.js'

// Header avatar/sign-in/sign-up. On mobile we render a Gravatar circle only —
// names blow out the navbar on narrow viewports. From sm+ we also show the
// name and role pill so admins can tell at a glance which token they're on.
export default function HeaderUserBadge() {
  const { me } = useMe()
  const authConfig = useAuthConfig()

  if (!isAuthenticated()) {
    const signIn = () => {
      redirectToOAuthSignIn(authConfig, {
        returnTo: window.location.pathname + window.location.search,
      }).catch((err) => console.error('[HeaderUserBadge] sign-in redirect failed:', err))
    }
    return (
      <div className="flex items-center gap-2">
        <Link
          to="/register"
          className="hidden min-h-[36px] items-center rounded-full px-3 text-sm text-slate-600 hover:text-brand-700 sm:inline-flex"
        >
          Sign up
        </Link>
        <button
          type="button"
          onClick={signIn}
          className={BTN_PRIMARY_SM}
        >
          Sign in
        </button>
      </div>
    )
  }

  const label = me?.displayName || me?.email || 'Account'

  return (
    <Link
      to="/admin"
      title={label}
      aria-label={label}
      className="inline-flex min-h-[36px] items-center gap-2 rounded-full bg-brand-50 pl-1 pr-1 text-sm font-medium text-brand-800 hover:bg-brand-100 sm:pr-3"
    >
      <Avatar email={me?.email} displayName={me?.displayName} size="h-7 w-7" />
      <span className="hidden max-w-[12ch] truncate sm:inline">{label}</span>
      {me?.role ? (
        <span
          className={`hidden rounded-full px-1.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide sm:inline ${
            me.role === 'VIEWER'
              ? 'bg-slate-100 text-slate-600'
              : 'bg-white/70 text-brand-700'
          }`}
        >
          {me.role}
        </span>
      ) : null}
    </Link>
  )
}
